import { useFlippers } from "../useFlippers";
import { useSharedGlobalConfig } from "../useSharedGlobalConfig";

const useStripeAdditionalInfo = (): Boolean => {
  const { isCanada } = useSharedGlobalConfig();
  const [stripeAdditionalInfoEnabled] = useFlippers("stripe_additional_info");

  return isCanada && stripeAdditionalInfoEnabled;
};

export { useStripeAdditionalInfo };
